// extracted by mini-css-extract-plugin
export default {"xModal":"xModal___fA5Jw","title":"title___oCIrQ","icon":"icon___NOZyj","hide-footer-after":"hide-footer-after___hBXUk"};